import { render, staticRenderFns } from "./ModalTwo.vue?vue&type=template&id=015be802&scoped=true&"
import script from "./ModalTwo.vue?vue&type=script&lang=js&"
export * from "./ModalTwo.vue?vue&type=script&lang=js&"
import style0 from "./ModalTwo.vue?vue&type=style&index=0&id=015be802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015be802",
  null
  
)

export default component.exports